(() => {
  class RmAccordion {
    constructor(root) {
      this.root = root;
      this.buttons = Array.from(root.querySelectorAll('[data-accordion-button]'));
      this.single = root.dataset.allowMultiple !== 'true';
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    init() {
      this.buttons.forEach((button) => {
        const panel = this.getPanel(button);
        if (!panel) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        panel.hidden = !expanded;
        panel.closest('[data-accordion-item]')?.classList.toggle('is-open', expanded);
        button.addEventListener('click', this.onClick);
        button.addEventListener('keydown', this.onKeydown);
      });
    }

    destroy() {
      this.buttons.forEach((button) => {
        button.removeEventListener('click', this.onClick);
        button.removeEventListener('keydown', this.onKeydown);
      });
    }

    getPanel(button) {
      const panelId = button.getAttribute('aria-controls');
      return panelId ? document.getElementById(panelId) : null;
    }

    setOpen(button, open) {
      const panel = this.getPanel(button);
      if (!panel) return;
      button.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      panel.closest('[data-accordion-item]')?.classList.toggle('is-open', open);
    }

    onClick(event) {
      const button = event.currentTarget;
      const willOpen = button.getAttribute('aria-expanded') !== 'true';

      if (this.single && willOpen) {
        this.buttons.forEach((current) => {
          if (current !== button) this.setOpen(current, false);
        });
      }

      this.setOpen(button, willOpen);
    }

    onKeydown(event) {
      const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (!keys.includes(event.key)) return;

      event.preventDefault();
      const index = this.buttons.indexOf(event.currentTarget);
      let nextIndex = index;

      if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.buttons.length;
      if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.buttons.length) % this.buttons.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.buttons.length - 1;

      this.buttons[nextIndex]?.focus();
    }
  }

  const instances = new WeakMap();

  const initAccordions = (scope = document) => {
    scope.querySelectorAll('[data-component="accordion"]').forEach((root) => {
      if (instances.has(root)) return;
      const instance = new RmAccordion(root);
      instance.init();
      instances.set(root, instance);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initAccordions());

  document.addEventListener('shopify:section:load', (event) => initAccordions(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-component="accordion"]').forEach((root) => {
      instances.get(root)?.destroy();
      instances.delete(root);
    });
  });

  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('[data-accordion-item]');
    const button = item?.querySelector('[data-accordion-button]');
    button?.click();
  });
})();
